<template>
    <v-dialog v-model="dialog" max-width="60%" v-resize="onResize">
        <v-card class="standard-row scroll-create-purchase-modal" style="border-radius: 10px; padding: 20px; ">
            <v-row no-gutters class="standard-row font-theme font-header-modal" style="padding-bottom: 10px;">
                <v-card-title style="font-weight: 700; font-size: 20px;" class=" set-center-document-modal">{{ getTitle() }}</v-card-title>
                <v-card-title style="font-weight: bold; font-size: 19px; margin-left: auto; " class="pr-sm-3 set-center-document-modal">Value :
                    {{ totalActual }}
                </v-card-title>
            </v-row>
            <v-card-text>
                <div v-for="(item,index) in selectedItemsFormatted" :key="index" style="font-weight:400;">
                    <v-row>
                        <v-col cols="12" sm="1" md="1" lg="1" style="font-weight:550">
                            {{ index + 1 }}
                        </v-col>
                        <v-col cols="12" sm="2" md="2" lg="2">
                            {{ item.sale_document }}
                        </v-col>
                        <v-col cols="12" sm="2" md="2" lg="2">
                            {{ item.document_id }}
                        </v-col>
                        <v-col cols="12" sm="3" md="3" lg="3">
                            {{ item.group_service }}
                        </v-col>
                        <v-col cols="12" sm="2" md="2" lg="2">
                            {{ item.actualFormatted }}
                        </v-col>
                        <v-col cols="12" sm="2" md="2" lg="2">
                            {{ item.revenueFormatted }}
                        </v-col>
                    </v-row>
                </div>
                <v-row no-gutters v-if="this.action === 'WaitQT'" class="standard-row font-theme pt-3" align="center">
                        <v-col cols="auto" sm="auto" md="auto" lg="auto" style="font-size: 15px;" class="ml-4 ml-sm-0">
                            Remark :
                        </v-col>
                        <v-col cols="" sm="" md="10" lg="10" class="ml-sm-8">
                            <v-text-field v-model="remark_qt" dense outlined hide-details color="back" background-color="#ffff" height="20" style="border-radius:5px;"></v-text-field>
                        </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions style="justify-content: center;">
                <!-- Use v-if to conditionally show the image -->
                <v-row no-gutters class="standard-row d-flex justify-center">
                    <div class="mr-3" style="padding-top: 10px;">
                        <v-btn v-if="this.action === 'SaveCsToPo'" @click="confirmCsToPo('SaveCsToPo')" color="#0EC62B3D"
                            class="elevation-0 font-theme confirm-btn" style="width: 119px; height: 30px;">
                            <v-icon color="#008000">mdi-check-bold</v-icon>
                            <!-- <img src="../assets/icons8-check-mark-48_2.png"
                                style="margin-right:10px; width: 18px; height: 17px;"> -->
                            ยืนยัน
                        </v-btn>
                        <v-btn v-if="this.action === 'RunPo'" @click="confirmCsToPo('RunPo')" color="#0EC62B3D"
                            class="elevation-0 font-theme confirm-btn" style="width: 119px; height: 30px;">
                            <v-icon color="#008000">mdi-check-bold</v-icon>
                            <!-- <img src="../assets/icons8-check-mark-48_2.png"
                                style="margin-right:10px; width: 18px; height: 17px;"> -->
                            ยืนยัน
                        </v-btn>
                        <v-btn v-if="this.action === 'WaitQT'" @click="confirmCsToPo('WaitQT')" color="#0EC62B3D"
                            class="elevation-0 font-theme confirm-btn" style="width: 119px; height: 30px;">
                            <v-icon color="#008000">mdi-check-bold</v-icon>
                            <!-- <img src="../assets/icons8-check-mark-48_2.png"
                                style="margin-right:10px; width: 18px; height: 17px;"> -->
                            ยืนยัน
                        </v-btn>
                    </div>
                    <div class="mr-3" style="padding-top: 10px;">
                        <v-btn @click="closeDialog" color="#E994948C" class="elevation-0 font-theme confirm-btn"
                            style="width: 119px; height: 30px;">
                            <v-icon color="#ff0000">mdi-close-thick</v-icon>
                            <!-- <img src="../assets/icons8-wrong-48_2.png"
                                style="margin-right:10px; width: 17px; height: 22px;"> -->
                            ยกเลิก
                        </v-btn>
                    </div>
                </v-row>
            </v-card-actions>
        </v-card>
        <SaveCreateCstoPo ref="confirmSaveCreateCstoPo" />
    </v-dialog>
</template>

<script>
import axios from 'axios';
import { MainFunction } from '@/functions/mainFunction.js'
import { EventBus } from '../EventBus'
import SaveCreateCstoPo from './SaveCreateCstoPo.vue';
export default {
    components: {
        SaveCreateCstoPo
    },
    data() {
        return {
            windowSize: { x: 0 },
            dialog: false,
            totalActual: null,
            selectedItemsFormatted: [],
            selectedItemsConfirm: [],
            action: '',
            remark_qt:'',
            headers: [
                { text: 'No', value: 'number' },
                { text: 'Sale Document', value: 'sale_document' },
                { text: 'Document ID', value: 'document_id' },
                { text: 'Group Service', value: 'group_service' },
                { text: 'Actual', value: 'actual' },
                { text: 'Revenue', value: 'revenue' },
            ],
        };
    },
    mounted() {
        this.onResize()
    },
    methods: {
        onResize() {
            this.windowSize = { x: window.innerWidth }
        },
        open(selectedItemsConfirm, action) {
            this.remark_qt = '';
            this.selectedItemsFormatted = Object.values(selectedItemsConfirm).map(item => ({
                ...item,
                actualFormatted: MainFunction.addComma(
                    parseFloat(item.actual.replace(/,/g, '').trim()) || 0
                ),
                revenueFormatted: MainFunction.addComma(
                    parseFloat(item.revenue.replace(/,/g, '').trim()) || 0
                )
            }));
            const totalActual = MainFunction.addComma(
                parseFloat(
                    Object.values(selectedItemsConfirm).reduce(
                        (sum, item) => sum + parseFloat(item.actual.replace(/,/g, '').trim() || 0),
                        0
                    )
                )
            );
            const totalQtValue = MainFunction.addComma(
                parseFloat(
                    Object.values(selectedItemsConfirm).reduce(
                        (sum, item) => sum + parseFloat(item.qt_value.replace(/,/g, '') || 0),
                        0
                    )
                )
            );
            this.totalQtValue = totalQtValue
            this.selectedItemsConfirm = selectedItemsConfirm
            this.totalActual = totalActual;
            this.action = action;
            this.dialog = true;
   
        },
        getTitle() {
            if (this.action === 'SaveCsToPo') {
                return 'บันทึกข้อมูล';
            } else if (this.action === 'RunPo') {
                return 'RUN PO';
            } else {
                return 'Wait QT';
            }
        },
        navigateToWaitQT() {
            // Navigate to the '/create_wait_qt' path
            this.$router.push({ path: '/create_cspo_wait_qt' });
        },
        closeDialog() {
            // ทำสิ่งที่คุณต้องการเมื่อ Confirm Dialog ถูกปิด
            // console.log('Confirm Dialog closed!');
            this.dialog = false;
            // อาจจะเรียก method หรือทำอื่นๆ ที่คุณต้องการ
        },
        confirmCsToPo(action) {
            this.action = action;
            const requestBody = {};
            if (action.toLowerCase() === "waitqt") {
                const mappingDataById = {};
                this.selectedItemsConfirm.forEach(({ _id, qt_vendor, qt_value, qt_remark, vendor,discount , terminate, terminate_date, status_terminate,from }) => {
                const vendorData = vendor ? { _id: vendor._id, vendor_name_th: vendor.vendor_name_th, discount }: null
                        if (!mappingDataById[_id]) {
                            mappingDataById[_id] = [{ qt_vendor, qt_value, qt_remark, vendor: vendorData, discount, terminate, terminate_date, status_terminate,from }]
                        }
                });
                requestBody.cs_list = Object.entries(mappingDataById).map(
                    ([_id, qt_list]) => {
                        return {
                            _id,
                            qt_list,
                            qt_remark: this.remark_qt,
                        };
                    }
                );
            } else {
                requestBody.cs_list = this.selectedItemsConfirm.map(
                    ({ _id, qt_vendor, qt_value, is_multi_qt, remark_qt, vendor, discount, terminate, terminate_date, status_terminate,from }) => {
                        return {
                            _id,
                            qt_vendor,
                            qt_value: qt_value.replace(/,/g, '') || "",
                            discount: discount.replace(/,/g, '') || "",
                            qt_remark: remark_qt,
                            vendor_id: vendor._id,
                            is_multi_qt: is_multi_qt ?? false,
                            terminate: terminate || '',
                            terminate_date: terminate_date || '',
                            status_terminate: status_terminate || '',
                            from:from || '',
                        };
                    }
                );
            }
            this.$refs.confirmSaveCreateCstoPo.open(
                action,
                this.selectedItemsConfirm,
                requestBody,
                this.totalActual,
                this.totalQtValue
            );
            this.dialog = false;
        },
        async confirmCsToPoStorage(action) {    // The original confirmCsToPo function version
            this.action = action;
            var cs_id_arr = []
            var body = {}
            this.selectedItemsConfirm.forEach((el) => {
                body = {
                    _id: el._id,
                    qt_vendor: el.qt_vendor || "",
                    discount: el.discount || "",
                    qt_value: el.qt_value || "",
                    is_multi_qt: el?.is_multi_qt || false
                }
                cs_id_arr.push(body)
            })
            // const csList = Object.values(this.selectedItemsConfirm).map(item => ({
            //     "sale_document": item.sale_document || "",
            //     "document_id": item.document_id || "",
            //     "job_status": item.job_status || "",
            //     "group_service": item.group_service || "",
            //     "service_name": item.service_name || "",
            //     "actual": item.actual || "",
            //     "revenue": item.revenue || "",
            //     "qt_vendor": item.qt_vendor || "",
            //     "qt_value": item.qt_value || "",
            //     "from_doc" : "cs_po"
            // }));
            // const requestBody = {
            //     "cs_list": csList
            // };
            const requestBody = {
                "cs_list" : cs_id_arr
            }
            this.$refs.confirmSaveCreateCstoPo.open(action, this.selectedItemsConfirm, requestBody, this.totalActual,this.totalQtValue);
            this.dialog = false
        }
    },
}
</script>
<style>
    .scroll-create-purchase-modal {
        max-height: calc(100vh - 254px);
        min-height: 254px !important;
        overflow-y: auto;
        border-radius: 20px !important;
    }

    .scroll-create-purchase-modal::-webkit-scrollbar {
        width: 12px;
    }

    .scroll-create-purchase-modal::-webkit-scrollbar-track {
        border-radius: 10px;
        background-color: transparent !important;
    }

    .scroll-create-purchase-modal::-webkit-scrollbar {
        width: 8px;
        background-color: transparent !important;
    }

    .scroll-create-purchase-modal::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background-color: #D9D9D9;
    }

    @media only screen and (max-width: 600px) {
        
        .set-center-document-modal {
            text-align: center;
        }
    }
</style>